import { useMemo } from 'react'

import { CommonPropsMedia, MediaActionsTypes } from './types'
import { modalsActions } from './utils'

type Props = {
  type: MediaActionsTypes
} & CommonPropsMedia

export const MediaActions = ({ type, ...props }: Props) => {
  const Component = useMemo(() => modalsActions[type], [type])

  if (!Component) return null

  return <Component {...props} />
}
